import { zodResolver } from '@hookform/resolvers/zod';
import { FC } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import MaterialTextField from 'src/components/material/textField';

import { CircularProgress } from '@mui/material';
import clsx from 'clsx';
import featureStyles from '../../RegisterModalShared.module.scss';
import { SecondStepInput, secondStepSchema } from '../const';

interface SecondStepProps {
  onSubmit: SubmitHandler<SecondStepInput>;
  loading: boolean;
  error: string;
}

export const SecondStep: FC<SecondStepProps> = ({
  onSubmit,
  loading,
  error,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<SecondStepInput>({
    resolver: zodResolver(secondStepSchema),
  });

  const onSubmitHandler = (data: SecondStepInput) => {
    onSubmit(data);
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmitHandler)}
      className={featureStyles.form}
      noValidate
    >
      <span>
        <Controller
          name="confirmationCode"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <MaterialTextField
              label="Confirmation Code"
              color="primary"
              variant="outlined"
              helperText={errors.confirmationCode?.message || error}
              error={!!(errors.confirmationCode || error)}
              {...field}
            />
          )}
        />
      </span>

      <button
        type="submit"
        className={clsx(featureStyles.button, featureStyles['button--primary'])}
        disabled={loading}
      >
        {loading ? (
          <CircularProgress sx={{ color: '#fff' }} size={28} thickness={4} />
        ) : (
          'Confirm'
        )}
      </button>
    </form>
  );
};
